import React, { useEffect, useState, useRef } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ReCAPTCHA from 'react-google-recaptcha';

import './Questionnaire.css';

const Questionnaire = () => {
	let questionnaire;
	if (process.env.NODE_ENV === 'development') {
		questionnaire = {
			"Steps": [
				{
					"Question": "Hur kan vi hjälpa dig?",
					"Description": null,
					"ImageUrl": "/ui/public/questionnaire-step-1.png",
					"IsMultiChoice": false,
					"AnswerRequired": true,
					"SelectAll": null,
					"Answers": [
						{
							"Id": "premises",
							"Text": "Jag letar efter en kommersiell lokal",
							"Payload": null
						},
						{
							"Id": "urbanservice",
							"Text": "Jag vill ha hjälp med Urban Service",
							"Payload": null
						},
						{
							"Id": "apartment",
							"Text": "Jag söker bostad",
							"Payload": null
						},
						{
							"Id": "other",
							"Text": "Jag vill ha hjälp med något annat",
							"Payload": null
						}
					]
				},
				{
					"Question": "Vilken stad är du intresserad av?",
					"Description": "Du kan välja fler än en",
					"ImageUrl": "/ui/public/questionnaire-step-2.png",
					"IsMultiChoice": true,
					"AnswerRequired": true,
					"SelectAll": "Välj alla",
					"Answers": [
						{
							"Id": "Borlänge",
							"Text": "Borlänge",
							"Payload": "/vara-lagenheter/borlange/"
						},
						{
							"Id": "Falun",
							"Text": "Falun",
							"Payload": "/vara-lagenheter/falun/"
						},
						{
							"Id": "Gävle",
							"Text": "Gävle",
							"Payload": "/vara-lagenheter/gavle/"
						},
						{
							"Id": "Luleå",
							"Text": "Luleå",
							"Payload": "/vara-lagenheter/lulea/"
						},
						{
							"Id": "Mora",
							"Text": "Mora",
							"Payload": "/vara-lagenheter/mora/"
						},
						{
							"Id": "Skellefteå",
							"Text": "Skellefteå",
							"Payload": "/vara-lagenheter/skelleftea/"
						},
						{
							"Id": "Sundsvall",
							"Text": "Sundsvall",
							"Payload": "/vara-lagenheter/sundsvall/"
						},
						{
							"Id": "Umeå",
							"Text": "Umeå",
							"Payload": "/vara-lagenheter/umea/"
						},
						{
							"Id": "Åre",
							"Text": "Åre",
							"Payload": "/vara-lagenheter/are/"
						},
						{
							"Id": "Östersund",
							"Text": "Östersund",
							"Payload": "/vara-lagenheter/ostersund/"
						}
					]
				}
			],
			"Result": {
				"StartAgain": "Börja om",
				"RecommendationHeading": "Vi tror att {0} är rätt person för dig!",
				"RecommendationPreamble": "Ta gärna kontakt via telefon eller e-post.",
				"ContactForm": {
					"Heading": "Det går även bra att lämna kontaktinformation via formuläret nedan så hör vi av oss.",
					"Name": "Namn",
					"Phone": "Telefon",
					"Email": "E-post",
					"SendButton": "Skicka min kontaktinformation",
					"SuccessMessage": "Tack! Vi hör av oss inom kort.",
					"ErrorMessage": "Oops! Något gick fel. Prova igen senare eller kontakta oss via telefon eller e-post.",
					"RecaptchaSiteKey": "6LdgWNYUAAAAABkrmDTfMLjPChTB1Xgcf--UUTXd"
				},
				"CityContactPersons": {
					"Borlänge": {
						"Id": 1,
						"Title": "Affärsutvecklare",
						"Name": "Sandrina Zetterström",
						"Phone": "+46 10 470 95 81",
						"Email": "sandrina.zetterstrom@dios.se",
						"ImageUrl": "/contentassets/b517593fffa546428a8a657258850d32/sandrina-zetterstrom?width=960"
					},
					"Falun": {
						"Id": 2,
						"Title": "Kundservice",
						"Name": "Elin Oscarsson",
						"Phone": null,
						"Email": "elin.oscarsson@dios.se",
						"ImageUrl": "/contentassets/2d0796f0de53454e8b38fc8de3a81937/elin-oscarsson?width=960"
					},
					"Gävle": {
						"Id": 3,
						"Title": null,
						"Name": " ",
						"Phone": null,
						"Email": null,
						"ImageUrl": "/ui/build/logo-dios-960.png"
					},
					"Luleå": {
						"Id": 4,
						"Title": null,
						"Name": " ",
						"Phone": null,
						"Email": null,
						"ImageUrl": "/ui/build/logo-dios-960.png"
					},
					"Mora": {
						"Id": 5,
						"Title": null,
						"Name": " ",
						"Phone": null,
						"Email": null,
						"ImageUrl": "/ui/build/logo-dios-960.png"
					},
					"Skellefteå": {
						"Id": 6,
						"Title": null,
						"Name": " ",
						"Phone": null,
						"Email": null,
						"ImageUrl": "/ui/build/logo-dios-960.png"
					},
					"Sundsvall": {
						"Id": 7,
						"Title": null,
						"Name": " ",
						"Phone": null,
						"Email": null,
						"ImageUrl": "/ui/build/logo-dios-960.png"
					},
					"Umeå": {
						"Id": 8,
						"Title": null,
						"Name": " ",
						"Phone": null,
						"Email": null,
						"ImageUrl": "/ui/build/logo-dios-960.png"
					},
					"Åre": {
						"Id": 9,
						"Title": null,
						"Name": " ",
						"Phone": null,
						"Email": null,
						"ImageUrl": "/ui/build/logo-dios-960.png"
					},
					"Östersund": {
						"Id": 10,
						"Title": null,
						"Name": " ",
						"Phone": null,
						"Email": null,
						"ImageUrl": "/ui/build/logo-dios-960.png"
					}
				},
				"AvailablePremisesContactPerson": {
					"Title": null,
					"Name": " ",
					"Phone": null,
					"Email": null,
					"ImageUrl": "/ui/build/logo-dios-960.png"
				},
				"UrbanServiceContactPerson": {
					"Title": null,
					"Name": " ",
					"Phone": null,
					"Email": null,
					"ImageUrl": "/ui/build/logo-dios-960.png"
				}
			},
			"PreviousStep": "Föregående",
			"NextStep": "Nästa"
		}
	} else {
		questionnaire = window.questionnaire;
	}
	if (!questionnaire)
		return null;
	
	const { Steps, Result, PreviousStep, NextStep } = questionnaire;
	const {
		StartAgain,
		RecommendationHeading,
		RecommendationPreamble,
		ContactForm,
		CityContactPersons,
		AvailablePremisesContactPerson,
		UrbanServiceContactPerson
	} = Result;
	
	const rootRef = useRef();
	const resultRef = useRef();
	const recaptchaRef = useRef();
	
	const [answers, setAnswers] = useState({
		helpId: '',
		helpText: '',
		cities: []
	});
	
	const [activeStep, setActiveStep] = useState(0);
	const [hasError, setHasError] = useState(false);
	const [hasSuccess, setHasSuccess] = useState(false);
	const [shouldRedirect, setShouldRedirect] = useState(false);
	const [captchaValue, setCaptchaValue] = useState('');
	const [helperPerson, setHelperPerson] = useState({
		Id: null,
		Title: '',
		Name: '',
		Phone: '',
		Email: ''
	});
	const [formData, setFormData] = useState({
		Name: '',
		Email: '',
		Phone: ''
	});
	
	useEffect(() => {
		if (window.innerWidth <= 1024
			|| document.documentElement.clientWidth <= 1024
			|| document.body.clientWidth <= 1024) {
			
			document.getElementById('questionnaire_root').scrollIntoView({behavior: 'smooth', block: 'start'});
		}
		
		if (activeStep === 2 && !!answers.cities.length) {
			if (answers.cities.length > 1) {
				if (answers.helpId === 'premises') {
					setHelperPerson({
						...AvailablePremisesContactPerson,
						Heading: prepareHeading(RecommendationHeading, AvailablePremisesContactPerson.Name)
					})
				} else if (answers.helpId === 'urbanservice') {
					setHelperPerson({
						...UrbanServiceContactPerson,
						Heading: prepareHeading(RecommendationHeading, UrbanServiceContactPerson.Name)
					})
				}
			} else {
				setHelperPerson({
					...CityContactPersons[answers.cities[0]],
					Heading: prepareHeading(RecommendationHeading, CityContactPersons[answers.cities[0]].Name)
				})
			}
			
			let cityWrapper = document.querySelector('#questionnaire_result')
			
			if (cityWrapper) {
				cityWrapper.style.setProperty('display', 'block');
				answers.cities.forEach((city, i) => {
					document.querySelector(`#${city}-toggle`).style.setProperty('display', 'flex');
					
					if (i === 0) {
						document.querySelector(`#${city}-toggle`).classList.add('active');
						document.querySelector(`#${city}-content`).style.setProperty('display', 'block');
					}
				})
			}
		}
	}, [activeStep])
	
	const prepareHeading = (heading, name) =>
		heading.replace('{0}', name);
	
	const onSubmit = async e => {
		e.preventDefault();
		setHasSuccess(false);
		setHasError(false);
		
		if (!captchaValue) {
			setHasError(true);
			return null;
		}
		
		await fetch('/api/questionnaire', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				...formData,
				SelectedHelpId: answers.helpId,
				SelectedHelpText: answers.helpText,
				SelectedCities: answers.cities,
				RecommendedContactPersonEmail: helperPerson.Email,
				RecommendedContactPersonName: helperPerson.Name,
				RecommendedContactPersonId: helperPerson.Id,
				['g-recaptcha-response']: captchaValue
			})
		})
			.then(({ok}) => {
				ok ? setHasSuccess(true) : setHasError(true);
			})
	}
	
	const selectAll = () => {
		answers.cities.length === Steps[1].Answers.length ?
			setAnswers({...answers, cities: []}) :
			setAnswers({...answers, cities: Steps[1].Answers.map(el => el.Id)})
	}
	
	const reset = () => {
		setActiveStep(0);
		setAnswers({helpId: '', helpText: '', cities: []});
		setFormData({Name: '', Email: '', Phone: ''});
		setHelperPerson({Title: '', Name: '', Phone: '', Email: ''});
		setShouldRedirect(false);
		setHasError(false);
		setHasSuccess(false);
		recaptchaRef.current.reset();
		
		let cityWrapper = document.querySelector('#questionnaire_result')
		let cityTogglers = document.querySelectorAll('.questionnaire_page_city_toggle');
		let cityContent = document.querySelectorAll('.questionnaire_page_city_content');
		if (cityWrapper && cityTogglers) {
			cityWrapper.style.setProperty('display', 'none');
			cityTogglers.forEach(toggle => {
				toggle.style.setProperty('display', 'none');
				toggle.classList.remove('active');
			})
			
			cityContent.forEach(content => content.style.setProperty('display', 'none'));
		}
	}
	
	const onChange = (helpText, helpId, city) => {
		if (city) {
			if (answers.cities.includes(city)) {
				let citiesArr = answers.cities;
				citiesArr.splice(answers.cities.indexOf(city), 1)
				setAnswers({...answers, cities: citiesArr})
			} else
				setAnswers({...answers, cities: [...answers.cities, city]})
		} else if (helpId === 'other') {
			setAnswers({...answers, helpText, helpId})
			if (window._imbox)
				window._imbox.push(['toggle'])
		} else {
			if (helpId === 'apartment')
				setShouldRedirect(true);
			
			setAnswers({...answers, helpText, helpId})
			setActiveStep(1);
		}
	}
	
	const onChangeCaptcha = value => {
		if (value) {
			setHasError(false);
			setCaptchaValue(value);
		}
	}
	
	const handleNextStep = () => {
		if (shouldRedirect) {
			let payload = Steps[1].Answers.find(({Id}) => Id === answers.cities[0]).Payload;
			
			if (!!answers.cities.length && payload) {
				window.location.href = payload
			} else {
				return null;
			}
		} else if (!!answers.cities.length)
			setActiveStep(2);
	}
	
	const handleScrollDown = () => {
		let el = document.getElementById('questionnaire_result');
		if (el)
			el.scrollIntoView({behavior: 'smooth', block: 'start'});
	}
	
	const onFormDataChange = (id, val) => {
		setHasSuccess(false);
		setHasError(false);
		setFormData({...formData, [id]: val})
		recaptchaRef.current.reset();
	}
	
	const NavIcon = () =>
		<svg
			className="footer__title__icon"
			width="26"
			height="26"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 26 26"
		>
			<g fill="#fff" fillRule="nonzero">
				<path
					d="M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0zm0 24.267C6.778 24.267 1.733 19.222 1.733 13 1.733 6.778 6.778 1.733 13 1.733c6.222 0 11.267 5.045 11.267 11.267A11.267 11.267 0 0113 24.267z"></path>
				<path d="M9.351 7.549L14.811 13l-5.46 5.451 1.231 1.231L17.255 13l-6.673-6.682z"></path>
			</g>
		</svg>
	
	return (
		<TransitionGroup className="questionnaire" ref={rootRef} id="questionnaire_root">
			{Steps.map((step, stepIndex) => {
				const { AnswerRequired, Answers, Description, ImageUrl, IsMultiChoice, Question, SelectAll } = step;
				const nodeRef = useRef();
				
				if (activeStep !== stepIndex) {
					return null;
				} else {
					return (
						<CSSTransition
							key={`step-${stepIndex}`}
							classNames="questionnaire_animation"
							nodeRef={nodeRef}
							mountOnEnter
							unmountOnExit
							timeout={{
								appear: 0,
								enter: 0,
								exit: 0,
							}}
						>
							<div
								className={`questionnaire_step ${stepIndex === activeStep ? 'active' : ''}`}
								key={`step-${stepIndex}`}
								ref={nodeRef}
							>
								<div className="questionnaire_step_wrapper">
									{Question && <h2 className="questionnaire_step_wrapper_question">{Question}</h2>}
									{Description && <p className="questionnaire_step_wrapper_description">{Description}</p>}
									{SelectAll && <span className="questionnaire_step_wrapper_selectAll" onClick={selectAll}>{SelectAll}</span>}
									{Answers &&
									<form className={`questionnaire_step_wrapper_form step-${stepIndex}`} onSubmit={e => e.preventDefault()}>
										{Answers.map((answer, index) => {
											return (
												<div className="questionnaire_step_wrapper_form_answer" key={`answer-${index}-step-${stepIndex}`}>
													<input
														required={AnswerRequired}
														id={`input-${answer.Id}`}
														type={IsMultiChoice ? 'checkbox' : 'radio'}
														onChange={() => IsMultiChoice ?
															onChange(null, null, answer.Id) :
															onChange(answer.Text, answer.Id)}
														checked={(answers.helpId === answer.Id) || (answers.cities.includes(answer.Id))}
													/>
													<label htmlFor={`input-${answer.Id}`} dangerouslySetInnerHTML={{__html: answer.Text}}/>
												</div>
											)
										})}
									</form>
									}
									{stepIndex === 1 &&
									<div className="questionnaire_step_wrapper_navigation">
										<div className="questionnaire_step_wrapper_navigation_back" onClick={reset}>
											<NavIcon/>
											{PreviousStep}
										</div>
										<div className="questionnaire_step_wrapper_navigation_forward" onClick={handleNextStep}>
											{NextStep}
											<NavIcon/>
										</div>
									</div>
									}
								</div>
								<img src={ImageUrl}/>
							</div>
						</CSSTransition>
					)
				}
			})}
			{activeStep === 2 &&
				<CSSTransition nodeRef={resultRef} classNames="questionnaire_animation" key={`step-2`} timeout={0}>
				<div className={`questionnaire_step ${2 === activeStep ? 'active' : ''}`} ref={resultRef}>
					<div className="questionnaire_step_wrapper result">
						<div className="questionnaire_step_wrapper_navigation top" onClick={reset}>
							<div className="questionnaire_step_wrapper_navigation_back">
								<NavIcon/>
								{StartAgain}
							</div>
						</div>
						{helperPerson && helperPerson.Name && helperPerson.Heading &&
						<h2 className="questionnaire_step_wrapper_question">{helperPerson.Heading}</h2>
						}
						{RecommendationPreamble &&
						<p className="questionnaire_step_wrapper_description">{RecommendationPreamble}</p>
						}
						<hr className="questionnaire_step_wrapper_linebreak"/>
						<div className="questionnaire_step_wrapper_contactform">
							{ContactForm.Heading && <h2 className="questionnaire_step_wrapper_question" dangerouslySetInnerHTML={{__html: ContactForm.Heading }}/>}
							<form
								onSubmit={onSubmit}
								className="questionnaire_step_wrapper_contactform_form"
							>
								<div className="questionnaire_step_wrapper_contactform_form_field wide">
									<label
										className="questionnaire_step_wrapper_contactform_form_field_label"
										htmlFor="Name"
									>
										{ContactForm.Name} *
									</label>
									<input
										className="questionnaire_step_wrapper_contactform_form_field_input"
										id="Name"
										required
										value={formData.Name}
										onChange={e => onFormDataChange('Name', e.target.value)}
									/>
								</div>
								<div className="questionnaire_step_wrapper_contactform_form_field">
									<label
										className="questionnaire_step_wrapper_contactform_form_field_label"
										htmlFor="Phone"
									>
										{ContactForm.Phone}
									</label>
									<input
										className="questionnaire_step_wrapper_contactform_form_field_input"
										id="Phone"
										value={formData.Phone}
										onChange={e => onFormDataChange('Phone', e.target.value)}
									/>
								</div>
								<div className="questionnaire_step_wrapper_contactform_form_field">
									<label
										className="questionnaire_step_wrapper_contactform_form_field_label"
										htmlFor="Email"
									>
										{ContactForm.Email} *
									</label>
									<input
										className="questionnaire_step_wrapper_contactform_form_field_input"
										id="Email"
										type="email"
										required
										value={formData.Email}
										onChange={e => onFormDataChange('Email', e.target.value)}
									/>
								</div>
								<ReCAPTCHA
									ref={recaptchaRef}
									sitekey={ContactForm.RecaptchaSiteKey}
									onChange={onChangeCaptcha}
								/>
								{hasError &&<p className="questionnaire_step_wrapper_contactform_error">{ContactForm.ErrorMessage}</p>}
								{hasSuccess && <p className="questionnaire_step_wrapper_contactform_success">{ContactForm.SuccessMessage}</p>}
								{(!hasError && !hasSuccess) && <button type="submit">{ContactForm.SendButton}</button>}
							</form>
						</div>
					</div>
					<div className="questionnaire_step_personInfo" style={{backgroundImage: `url(${helperPerson.ImageUrl})`}}>
						{helperPerson && helperPerson.Name &&
						<div className="questionnaire_step_personInfo_box">
							<h3 className="questionnaire_step_personInfo_box_title">{`${helperPerson.Name} - ${helperPerson.Title}`}</h3>
							<a href={`tel:${helperPerson.Phone}`} className="questionnaire_step_personInfo_box_phone">{helperPerson.Phone}</a>
							<a href={`mailto:${helperPerson.Email}`} className="questionnaire_step_personInfo_box_email">{helperPerson.Email}</a>
						</div>
						}
					</div>
					<div className="questionnaire_step_scrollDown" onClick={handleScrollDown}/>
				</div>
			</CSSTransition>
			}
		</TransitionGroup>
	);
};

export default Questionnaire;


// WEBPACK FOOTER //
// ./src/js/components/Questionnaire.js